import React from 'react'
import NumberFormat from 'react-number-format'
import { HeaderBar } from '../../component'
import './style.css'
import { useSelector } from 'react-redux'
import { RootReducers } from '../../redux/reducers'
import info from '../../assets/images/info.svg'
import {
  DisplayDateFormat,
  DisplayStatusName,
  DisplayDateToThaiDateFormat,
  DisplayToThaiDateFormat,
  maskingEmail,
  maskingMobileNo
} from '../../helpers/texthelper'
import { PaymentObjectiveModel } from '../../models/paymentObjective'
import { DocumentDetailModel } from '../../models/documentDetail'
import { RoundNumber } from '../../helpers/Number'
import { ETR_STATUS } from '../../constants'
import { DocumentModel } from '../../models/document'
import { stringify } from 'querystring'
import { CashDetail } from './cashDetail'
import { ChequeDetail } from './chequeDetail'
import { CreditCardDetail } from './creditCardDetail'
import { CashPayInDetail } from './cashPayInDetail'
import { ChequePayInDetail } from './chequePayInDetail'
import { CompanyChequeDetail } from './companyChequeDetail'
import { QRCodeDetail } from './qrCodeDetail'

interface EtrDetailProps {
  documentData: DocumentModel | null
  isMasking: boolean
  isPreview: boolean
}

export const EtrDetail: React.VFC<EtrDetailProps> = ({ documentData, isMasking }) => {
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  //const documentData = useSelector((state: RootReducers) => state.documentDetailReducer)

  const total = (): number => {
    let totalPaymentDetail = 0
    documentData?.documentDetails?.forEach(item => {
      totalPaymentDetail += +item.paymentAmount
    })

    return RoundNumber(totalPaymentDetail)
  }

  const getStatusDate = (doc: DocumentModel | null) => {
    if (doc) {
      switch (doc.status) {
        case ETR_STATUS.CANCEL_ETR:
          return DisplayToThaiDateFormat(doc.canceldate as Date)
        case ETR_STATUS.SUCCESS_ETR:
          return DisplayToThaiDateFormat(doc.statusDate as Date)
        default:
          return DisplayToThaiDateFormat(doc.created as Date)
      }
    }
    return ''
  }
  const renderPaymentObjective = (paymentObjectives: PaymentObjectiveModel[]) => {
    paymentObjectives &&
      paymentObjectives.sort((a: PaymentObjectiveModel, b: PaymentObjectiveModel) => {
        return a.paymentObjectiveType.id - b.paymentObjectiveType.id
      })
    return (
      paymentObjectives &&
      paymentObjectives.map((item: PaymentObjectiveModel) => {
        return (
          <div className="flex-item" key={item.id}>
            <div className="flex-container-detail">
              <div className="flex-item-detail">
                <li>{item.paymentObjectiveType.name}</li>
              </div>
              <div className="flex-item-detail amount-right">
                <span>
                  <NumberFormat
                    thousandsGroupStyle="thousand"
                    value={item.amount}
                    prefix=""
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    allowNegative={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </span>{' '}
                บาท
              </div>
            </div>
          </div>
        )
      })
    )
  }

  const rendderDocumentDetail = (documentDetails: DocumentDetailModel[]) => {
    documentDetails &&
      documentDetails.sort((a: DocumentDetailModel, b: DocumentDetailModel) => {
        return a.paymentMethod.id - b.paymentMethod.id
      })
    return (
      documentDetails &&
      documentDetails.map((item: DocumentDetailModel) => {
        switch (item.paymentMethod.id) {
          case 1:
            return <CashDetail item={item}></CashDetail>
          case 2:
            return <ChequeDetail item={item}></ChequeDetail>

          case 3:
            return <CreditCardDetail item={item}></CreditCardDetail>
          case 4:
            return (
              <>
                <div className="flex-container">
                  <div className="flex-item-left">
                    <div className="flex-container-cc">
                      <div className="flex-item-cc-left">
                        <li>
                          <span>{item.paymentMethod.name}</span>{' '}
                        </li>
                      </div>
                      <div className="flex-item-cc-right hide">หมายเหตุ :{item.other_Pay}</div>
                    </div>
                  </div>
                  <div className="flex-item-right amount-right hide">
                    <span>
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={item.paymentAmount}
                        prefix=""
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </span>{' '}
                    บาท
                  </div>
                </div>
              </>
            )
          case 5:
            return <CashPayInDetail item={item}></CashPayInDetail>
          case 6:
            return <ChequePayInDetail item={item}></ChequePayInDetail>
          case 7:
            return <CompanyChequeDetail item={item}></CompanyChequeDetail>
          case 8:
            return <QRCodeDetail item={item}></QRCodeDetail>
          default:
            break
        }
      })
    )
  }
  return (
    <div>
      <div className="content-detail">
        <div className="agent-Detail">
          <div className="bold">ข้อมูลตัวแทน</div>
          <hr></hr>
          <div className="flex-container">
            <div className="flex-item">ตัวแทน : {documentData?.agent?.name}</div>
            <div className="flex-item">รหัสตัวแทน : {documentData?.agent?.agentId}</div>
            <div className="flex-item">อีเมล : {documentData?.agent?.email}</div>
            <div className="flex-item">
              สาขา : {documentData?.agent?.branchCode} - {documentData?.agent?.branchName}{' '}
            </div>
          </div>
        </div>
        <div className="customer-Detail">
          <div className="bold">ข้อมูลกรมธรรม์ลูกค้า</div>
          <hr></hr>
          <div className="flex-container">
            <div className="flex-item">เลขที่กรมธรรม์ : {documentData?.policyNo}</div>
            <div className="flex-item">ผู้เอาประกัน : {documentData?.insuredName}</div>
            <div className="flex-item">แบบประกัน : {documentData?.planName}</div>
            <div className="flex-item">
              วันเดือนปีเกิด : {DisplayDateToThaiDateFormat(documentData?.customerDOB)}
            </div>
            <div className="flex-item">
              จำนวนเงินเอาประกัน (บาท) :{' '}
              <NumberFormat
                thousandsGroupStyle="thousand"
                value={documentData?.sumAssured}
                prefix=""
                decimalSeparator="."
                displayType="text"
                type="text"
                thousandSeparator={true}
                allowNegative={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </div>
            <div className="flex-item">
              อีเมล :{' '}
              {isMasking
                ? maskingEmail(documentData?.customerMail as string)
                : documentData?.customerMail}
            </div>
            <div className="flex-item">งวดชำระ : {documentData?.paymentFrequency}</div>
            <div className="flex-item">
              เบอร์โทรศัพท์ :{' '}
              {isMasking
                ? maskingMobileNo(documentData?.customerPhone as string)
                : documentData?.customerPhone}
            </div>
          </div>
        </div>
        <div className="payment-Detail">
          <div className="bold">รายการการรับเงินค่าเบี้ยประกันภัย และอื่นๆ</div>
          <hr></hr>
          <div className="payer">ได้รับเงินจาก : {documentData?.payerName}</div>
          <div className="pay-for">เพื่อชำระ :</div>
          <div className="flex-container">
            {renderPaymentObjective(documentData?.paymentObjectives as PaymentObjectiveModel[])}
          </div>
          <div className="pay-with">ชำระโดย :</div>
          <div className="doc-detail-container">
            {rendderDocumentDetail(documentData?.documentDetails as DocumentDetailModel[])}
          </div>
          <div className="total-container">
            <div className="flex-container">
              <div className="flex-item-left">จำนวนเบี้ยชำระทั้งหมด :</div>
              <div className="flex-item-right amount-right">
                <span>
                  <NumberFormat
                    thousandsGroupStyle="thousand"
                    value={total()}
                    prefix=""
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    allowNegative={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </span>{' '}
                บาท
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  )
}
